

<template>
  <div class="check-group">
    <el-checkbox-group v-model="checkList">
      <div v-for="(item, idx) in options">
        <el-checkbox
          :key="idx"
          :label="item.name"
          :value="item.value"
        ></el-checkbox>
      </div>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: "FormDisplayList",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String,
  },
  data() {
    return {
      options: [
        {
          name: "Books",
          value: "Books",
        },
        {
          name: "Children’s Books",
          value: "Children’s Books",
        },
        {
          name: "Textbooks & Workbooks",
          value: "Textbooks & Workbooks",
        },
        {
          name: "Stationary",
          value: "Stationary",
        },
        {
          name: "Toys & Gifts",
          value: "Toys & Gifts",
        },
        {
          name: "Electronics",
          value: "Electronics",
        },
        {
          name: "Food & Wellness",
          value: "Food & Wellness",
        },
        {
          name: "Fitness & Travel",
          value: "Fitness & Travel",
        },
        {
          name: "Others",
          value: "Others",
        },
      ],
    };
  },

  computed: {
    checkList: {
      get() {
        if (!!this.value) {
          try {
  
            return JSON.parse(this.value);
          } catch (error) {}
        }
        return [];
      },
      set(val) {
        this.emitCheckList(val);
      },
    },
  },
  methods: {
    emitCheckList(val) {
      try {
        this.$emit("change", JSON.stringify(val));
      } catch (error) {
        console.log("emit fail", error);
      }
    },
  },
  mounted() {},
};
</script>

<style></style>
